import { StyledEngineProvider, ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import React from 'react';
import { theme } from '../../utils/Theme';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error, errorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo && false) {
      // Error path
      if (process.env.NODE_ENV === 'development')
        return (
          <StyledEngineProvider injectFirst>
            <MuiThemeProvider theme={theme}>
              <div style={styles.page}>
                {process.env.NODE_ENV === 'development' ? (
                  <>
                    <h2>You did it again!</h2>
                    <details style={{ whiteSpace: 'pre-wrap' }}>
                      {this.state.error && this.state.error.toString()}
                      <br />
                      {this.state.errorInfo.componentStack}
                    </details>
                  </>
                ) : (
                  <h2>Something went wrong.</h2>
                )}
              </div>
            </MuiThemeProvider>
          </StyledEngineProvider>
        );
    }
    // Normally, just render children
    return this.props.children;
  }
}

const styles = {
  page: {
    padding: '40px',
    height: '100vh',
    width: '100vw',
    display: 'grid',
    gridTemplateColumns: '250px auto',
    gridTemplateRows: '64px auto',
    overflowY: 'hidden',
  },
};
